import CreateCopyViewButton from '@components/copy-view/CreateCopyViewButton';
import { SavedViewButtonsTrackingTags } from '@ecosystem/newron-client-lib';
import { TradingAssistantViewState } from '@models/SavedViews';

interface ExportCopyViewButtonProps {
  tradingAssistantViewState: TradingAssistantViewState;
  copyViewTracking: Object;
}

const TradingAssistantCopyViewButton: React.FC<ExportCopyViewButtonProps> = ({
  copyViewTracking,
  tradingAssistantViewState,
}) => {
  const createViewState = () => {
    return tradingAssistantViewState;
  };
  const createTrackingTags = () => {
    return copyViewTracking as SavedViewButtonsTrackingTags;
  };
  return <CreateCopyViewButton createViewFunction={createViewState} copyViewTracking={createTrackingTags} />;
};

export default TradingAssistantCopyViewButton;
